import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';
import { CheckCircle, AlertCircle } from 'lucide-react';

interface ConfidenceProps {
  score: number;
}

export const ConfidenceIndicator: React.FC<ConfidenceProps> = ({ score }) => {
  // Only show for very high or very low confidence
  if (score > 0.85) {
    return (
      <Tooltip>
        <TooltipTrigger>
          <span className="inline-flex items-center gap-1.5 px-2 py-1 bg-green-50 dark:bg-green-950/20 border border-green-200 dark:border-green-800/30 rounded-md">
            <CheckCircle className="h-3.5 w-3.5 text-green-600 dark:text-green-400" />
            <span className="text-xs font-medium text-green-700 dark:text-green-300">
              High confidence
            </span>
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" align="center" className="max-w-xs">
          <p>Based on strong evidence in the knowledge base</p>
        </TooltipContent>
      </Tooltip>
    );
  }

  if (score < 0.4) {
    return (
      <Tooltip>
        <TooltipTrigger>
          <span className="inline-flex items-center gap-1.5 px-2 py-1 bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-800/30 rounded-md">
            <AlertCircle className="h-3.5 w-3.5 text-amber-600 dark:text-amber-400" />
            <span className="text-xs font-medium text-amber-700 dark:text-amber-300">
              Limited information
            </span>
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" align="center" className="max-w-xs">
          <p>Based on limited information in the knowledge base</p>
        </TooltipContent>
      </Tooltip>
    );
  }

  return null;
};

export default ConfidenceIndicator;